import axios from "axios";

import {
  getLangAll,
  getNextClass,
  getNotifLength,
  getClassesForRating,
  getLingoRatingCriterias,
} from "./generic.middleware";
import i18n from "../../i18n";
import api from "../../services/api";
import { clearState } from "../slices/student.slice";
import { getConfirmClass } from "./teacher.middleware";
import { encryptValue } from "../../utils/fieldEncrypt";
import { clearStateTeacher } from "../slices/teacher.slice";
import { handleTranslateAsyncStorage } from "../../utils/utils";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { getClassWithoutTeacher } from "./companyManager.middleware";
import { getStudentPlansUser, getClassRoom } from "./student.middleware";
import { setAffiliateInfo, setIsAffiliate } from "../slices/affiliate.slice";
import { getAffiliateInfo, getCanBeAffiliate } from "./affiliate.middleware";
import { setCheckout, setFirstAccess, setUser, unsetUser } from "../slices/user.slice";
import { setClassesWithoutTeacher, setClassesWithoutTeacherDemo } from "../slices/companyManager.slice";
import { initLoading, endLoading, setError, unsetError, setAllClasses } from "../slices/generics.slice";

export const loadUserStorage = (loading = false, updateTeacher = false, where = "") => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    console.log(where);

    const result = sessionStorage.getItem("@dataUser");

    const dataUser = JSON.parse(result);

    try {
      if (updateTeacher) {
        await dispatch(getNextClass());
        await dispatch(getConfirmClass(dataUser?.teacherId));
        await dispatch(getNotifLength(dataUser?.id));
      } else {
        if (dataUser?.role === "companyManager" || dataUser?.role === "customerService") {
          await dispatch(getClassWithoutTeacher(false, false));
          await dispatch(getClassWithoutTeacher(true, false));
        }
        await dispatch(setUser(dataUser));

        await dispatch(getLangAll());
        await dispatch(getCanBeAffiliate(dataUser?.id));
        await dispatch(getAffiliateInfo(dataUser?.id));

        if (dataUser?.role === "student") {
          await dispatch(getStudentPlansUser(dataUser?.id));
          await dispatch(getClassRoom(dataUser?.id));
          await dispatch(getLingoRatingCriterias());
        }

        await dispatch(getNextClass());
        await dispatch(getNotifLength(dataUser?.id));

        if (dataUser?.role === "teacher") {
          await dispatch(getConfirmClass(dataUser?.teacherId));
        }

        await dispatch(setFirstAccess(false));
      }
      loading && dispatch(endLoading());
      return dataUser?.role;
    } catch (error) {
      console.log("loadUserStorage", error?.data);
      loading && dispatch(endLoading());
    }
  };
};

export const postChangePass = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/admin/users/changepassword`, data);
      const resp = response?.data?.result?.items[0];
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postChangePass", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const login = (userData, loading = false) => {
  return async (dispatch) => {
    loading && (await dispatch(initLoading()));
    await dispatch(clearState());
    await dispatch(setAllClasses([]));
    await dispatch(setIsAffiliate([]));
    await dispatch(clearStateTeacher());
    await dispatch(setAffiliateInfo([]));
    await dispatch(setClassesWithoutTeacher([]));
    await dispatch(setClassesWithoutTeacherDemo([]));

    try {
      const userDataForm = {
        strategy: userData.strategy,
        email: encryptValue(userData.email),
        password: encryptValue(userData.password),
      };

      const response = await api.post("/login", userDataForm);

      if (response.data) {
        if (response?.status === 200 || response?.status === 201) {
          let token = await handleTranslateAsyncStorage(response?.data?.token);

          const newData = {
            id: token.id,
            role: token.role,
            picture: token.picture,
            timezone: token.timezone,
            betaTester: token.betaTester,
            firstAccess: token.firstAccess,
            name: encryptValue(token.name),
            email: encryptValue(token.email),
            notifyControl: token.notifyControl,
            timeDisplayFormat: token.timeDisplayFormat,
            nativeLanguageName: token.nativeLanguageName,
            teacherId: response?.data?.teacherId ?? null,
            studentId: response?.data?.studentId ?? null,
            token: response?.data?.token,
          };

          const languages = { english: "en", portuguese: "pt", spanish: "es" };

          const nativeLanguageName = languages[newData.nativeLanguageName?.toLowerCase()] ?? "en";

          if (newData?.role !== "affiliate") {
            localStorage.setItem("i18nextLng", nativeLanguageName);
            i18n.changeLanguage(nativeLanguageName);
          }

          sessionStorage.setItem("@dataUser", JSON.stringify(newData));

          if (sessionStorage.getItem("@remember") === "S") {
            sessionStorage.setItem("@rememberEmail", newData?.email);
          }

          await dispatch(setUser(newData));
          await dispatch(setFirstAccess(true));

          loading && (await dispatch(endLoading()));

          return newData;
        } else {
          dispatch(setError("Houve um ou mais erros ao carregar o usuário."));
          loading && (await dispatch(endLoading()));
          return false;
        }
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      if (error.response?.status === 401) {
        const customError = new Error("Not Authorized");
        customError.customMessage = "NOT_AUTHORIZED";
        throw customError;
      }
      loading && (await dispatch(endLoading()));
      throw error;
    } finally {
      loading && (await dispatch(endLoading()));
    }
  };
};

export const firstLogin = (newData, loading = false) => {
  return async (dispatch) => {
    loading && (await dispatch(initLoading()));

    try {
      if (newData.id) {
        await dispatch(getCanBeAffiliate(newData.id));
        await dispatch(getAffiliateInfo(newData.id));

        if (newData?.role === "companyManager" || newData?.role === "customerService") {
          await dispatch(getClassWithoutTeacher(false, false));
          await dispatch(getClassWithoutTeacher(true, false));
        }

        if (newData.role === "student") {
          await dispatch(getStudentPlansUser(newData.id));
          await dispatch(getClassRoom(newData.id));
          await dispatch(getLingoRatingCriterias());
        }

        await dispatch(getLangAll());
        await dispatch(getNextClass());
        await dispatch(getNotifLength(newData.id));

        if (newData.role === "teacher") {
          await dispatch(getConfirmClass(newData.teacherId));
        }
        loading && (await dispatch(endLoading()));

        return true;
      }
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      loading && (await dispatch(endLoading()));
    }
  };
};

export const loginCheckout = (userData) => {
  return async (dispatch) => {
    await dispatch(setCheckout(true));
    await dispatch(initLoading());

    try {
      const userDataForm = {
        strategy: userData.strategy,
        email: encryptValue(userData.email),
        password: encryptValue(userData.password),
      };

      const response = await api.post("/login", userDataForm);

      if (response?.status === 200 || response?.status === 201) {
        let token = await handleTranslateAsyncStorage(response?.data?.token);

        const newData = {
          id: token.id,
          role: token.role,
          picture: token.picture,
          timezone: token.timezone,
          betaTester: token.betaTester,
          firstAccess: token.firstAccess,
          name: encryptValue(token.name),
          email: encryptValue(token.email),
          notifyControl: token.notifyControl,
          timeDisplayFormat: token.timeDisplayFormat,
          nativeLanguageName: token.nativeLanguageName,
          teacherId: response?.data?.teacherId ?? null,
          studentId: response?.data?.studentId ?? null,
          token: response?.data?.token,
        };

        await sessionStorage.setItem("@dataUser", JSON.stringify(newData));

        await dispatch(setUser(newData));
        await dispatch(setFirstAccess(true));

        return true;
      } else {
        dispatch(setError("Houve um ou mais erros ao carregar o usuário."));
        await dispatch(endLoading());
        return false;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      if (error.response?.status === 401) {
        const customError = new Error("Not Authorized");
        customError.customMessage = "NOT_AUTHORIZED";
        throw customError;
      }
      await dispatch(endLoading());
      throw error;
    } finally {
      //await dispatch(endLoading());
    }
  };
};

export const sendForgot = (userData) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/forgotPassword", JSON.stringify(userData));

      if (response.data.success) {
        return response.data;
      } else {
        dispatch(setError({ message: "Houve um ou mais erros." }));
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("sendForgot", error);
      dispatch(endLoading());
      throw error.response.data.error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const loginSocialGoogle = (userData) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/", userData);

      if (response.data.success) {
        dispatch(unsetError());
      } else {
        dispatch(setError({ message: "Houve um ou mais erros." }));
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("sendForgot", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updatePasswordUser = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`admin/users/changepassword`, data);
      return response.status;
    } catch (error) {
      console.log("sendForgot", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    try {
      if (window?.caches) {
        caches.keys().then((cacheNames) => cacheNames.forEach((cacheName) => caches.delete(cacheName)));
      }

      sessionStorage.clear();
      await dispatch(unsetUser({ user: null, isAuthenticated: false }));
    } catch (error) {
      console.log("logout", error);
    }
  };
};

export const getAdminUserInfo = (url, loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());
    try {
      const response = await api.get(url);
      return response?.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getAdminUserInfo", error);
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const refreshTokenUser = (user) => {
  return async (dispatch) => {
    dispatch(clearState());
    dispatch(clearStateTeacher());
    console.log("refreshTokenUser");
    try {
      const response = await api.get("token/refresh", { params: { token: user.token } });

      if (response.data) {
        if (response?.status === 200 || response?.status === 201) {
          let token = handleTranslateAsyncStorage(response?.data);

          const newData = {
            id: token.id,
            role: token.role,
            picture: token.picture,
            timezone: token.timezone,
            betaTester: token.betaTester,
            firstAccess: token.firstAccess,
            name: encryptValue(token.name),
            email: encryptValue(token.email),
            notifyControl: token.notifyControl,
            timeDisplayFormat: token.timeDisplayFormat,
            nativeLanguageName: token.nativeLanguageName,
            teacherId: response?.data?.teacherId ?? null,
            studentId: response?.data?.studentId ?? null,
            token: response?.data?.token,
          };

          sessionStorage.setItem("@dataUser", JSON.stringify(newData));

          await dispatch(setUser({ ...user, newData }));

          await dispatch(getLangAll());
          await dispatch(getCanBeAffiliate(newData?.id));
          await dispatch(getAffiliateInfo(newData?.id));

          if (newData?.role === "student") {
            console.log("passou aqrui", newData.id);
            await dispatch(getStudentPlansUser(newData.id));
            await dispatch(getClassRoom(newData.id));
            await dispatch(getLingoRatingCriterias());
            await dispatch(getClassesForRating(newData));
          }

          if (newData?.role === "teacher") {
            await dispatch(getConfirmClass(newData?.teacherId));
          }

          await dispatch(getNextClass());
          await dispatch(getNotifLength(newData?.id));

          if (sessionStorage.getItem("@remember") === "S") {
            sessionStorage.setItem("@rememberEmail", newData?.email);
          }

          return true;
        } else {
          dispatch(setError("Houve um ou mais erros ao carregar o usuário."));
          return false;
        }
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      if (error.response?.status === 401) {
        const customError = new Error("Not Authorized");
        customError.customMessage = "NOT_AUTHORIZED";
        throw customError;
      }
      dispatch(endLoading());
      throw error;
    }
  };
};

export const updateUserInfo = (url, data, type) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(url, data);
      const item = await response?.data?.result?.items[0];
      console.log("updateUserInfo", item);
      if (response?.data) {
        if (type === "manageAccount") {
          const newData = {
            id: item.id,
            role: item.role,
            name: item.name,
            email: item.email,
            firstAccess: false,
            picture: item.picture,
            timezone: item.timezone,
            betaTester: item.betaTester,
            notifyControl: item.notifyControl,
            timeDisplayFormat: item.timeDisplayFormat,
            token: response.config.headers.Authorization.split(" ")[1],
            teacherId: item?.teachers?.length > 0 ? item?.teachers[0]?.id : null,
            studentId: item?.students?.length > 0 ? item?.students[0]?.id : null,
            nativeLanguageName:
              item?.students?.length > 0
                ? decryptIfEncrypted(item?.students[0]?.studentLanguages[0]?.language.name)
                : null,
          };

          await dispatch(setUser(newData));
          sessionStorage.setItem("@dataUser", JSON.stringify(newData));
        }

        return response;
      }
    } catch (error) {
      console.log("updateUserInfo", error);
      throw error.response.data.error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateStatusStudentB2B = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("studentManagement/updateStatusStudentB2B", data);
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("updateStatusStudentB2B", error.message);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const newPurchasePlan = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("accountManagement/newPurchasePlan", data);

      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("newPurchasePlan", error.message);

      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const verifyToken = (forgetToken) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`token/verify?token=${forgetToken}`);

      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("verifyToken", error.message);

      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const changePassword = (data, token) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const header = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await api.post(`admin/users/changepassword`, data, {
        headers: header,
      });

      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("changePassword", error.message);

      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPictureUrl = (userID, fileName) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const payload = { fileName };

    try {
      const response = await api.post(`/admin/users/${userID}/picture-get-url`, payload);
      return response.data.result.items[0];
    } catch (error) {
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putUploadAvatar = (url, payload, type) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await axios.put(url, payload, {
        headers: { "Content-Type": type },
      });

      return response;
    } catch (error) {
      dispatch(endLoading());
      // throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const successUploadAvatar = (userID, fileName) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const payload = { fileName };

    try {
      const response = await api.post(`/admin/users/${userID}/confirm-upload-avatar`, payload);

      if (response.data.success) {
        const result = sessionStorage.getItem("@dataUser");
        const dataUser = JSON.parse(result);

        const picture = response.data?.result?.items[0];
        await dispatch(setUser({ ...dataUser, picture }));
        if (dataUser) {
          sessionStorage.setItem("@dataUser", JSON.stringify({ ...dataUser, picture }));
        } else {
          console.log("dataUser inválido");
        }

        return picture;
      }
    } catch (error) {
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};
